<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          class="truncate"
          routeBack="TechnicianIndex"
          :title="$t('Technician') + ' - ' + getValue('fullname')"/>
        <show-actions
          :deleteItem=allowDelete
          :editItem=allowEdit
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Lastname') }}</div>
                  <div> {{ getValue('user.lastName') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Firstname') }}</div>
                  <div> {{ getValue('user.firstName') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.PhoneNumber') }}</div>
                  <div> {{ getValue('user.phoneNumber') }}</div>
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Username') }}</div>
                  <div> {{ getValue('user.username') }}</div>
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('technician.department.follow') }}</div>
                  <div> {{ formatDepartment(getValue('department')) }}</div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="d-flex flex-column mb-4 custom-border">
                </div>
              </div>

              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('technician.Structure') }}</div>
                  <div> {{ getValue('structure.tostring') }}</div>
                </div>
              </div>
            </div>
            <div class="row" v-if="this.farmers.length>0">
              <div class=col-md-6>
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Farmers') }}</div>
                  <div class="d-flex">
                    <div v-for="farmer in this.farmers" class="mr-4 textual-link" @click="goToFarmer(farmer.id)"> {{ farmer.tostring }}</div>
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="technician"
      controllerName="technician"
      itemSingularName="technician"
      itemSingularNameUpp="Technician"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'TechnicianShow',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    ItemDeleteModal,
    ShowActions
  },

  data () {
    return {
      techId: this.$route.params.techId,
      technician: {},
      allowDelete: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin || this.$store.getters.isStructure,
      allowEdit: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin || this.$store.getters.isStructure,
      farmers: []
    }
  },

  mounted () {
    this.fetchData()
  },

  watch: {
    'technician': async function () {
      if (this.technician && this.technician.nbFarmers > 0) {
        await this.fetchFarmerForTechnician()
      }
    }
  },

  computed: {
    getValue() {
      return (path) => {
        const properties = path.split('.');
        let value = properties.reduce((prev, curr) => {
          return prev && prev[curr] ? prev[curr] : null;
        }, this.technician);
        return value !== null ? value : 'N/A';
      };
    }
  },

  methods: {

    formatDepartment (value) {
      if(value==='N/A') return 'N/A'
      return value.map(item => item.num_dep).join(', ')
    },

    async fetchData () {
      if (this.techId) {
        await this.fetchTechnician()
        if (this.technician && this.technician.nbFarmers > 0) {
          await this.fetchFarmerForTechnician()
        }
      }
    },

    async fetchTechnician () {
      api
        .get('/technician/' + this.techId)
        .then(response => {
          this.technician = response.data
          if (this.technician.isDefaultTechnician) {
            this.$router.push({
                name: 'TechnicianIndex'
              },
              () => {
                this.$nextTick(() => {
                  this.$bvToast.toast(this.$i18n.t('unauthorized.error'), {
                    title: this.$i18n.t('Error.title'),
                    autoHideDelay: 4000,
                    toaster: 'b-toaster-bottom-right',
                    solid: true
                  })
                })
              })
          }
        })
    },

    async fetchFarmerForTechnician () {
      api
        .get('/technician/getAllFarmersForTechnician/' + this.techId)
        .then(response => {
          this.farmers = response.data
        })
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'TechnicianEdit',
        params: {
          techId: this.technician.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteItem () {
      this.$router.push({
        name: 'TechnicianIndex'
      })
    },

    goToFarmer (id) {
      this.$router.push({
        name: 'FarmerShow',
        params: {
          farmerId: id
        }
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/TechnicianShow.vue